import React, {
  useRef, useState, useEffect, forwardRef, useImperativeHandle,
} from 'react';
import PropTypes from 'prop-types';
import { BiLock, BiLockOpen } from 'react-icons/bi';
import { Controller, useWatch } from 'react-hook-form';
import styles from './textarea.module.scss';

const Textarea = forwardRef(({
  name,
  control,
  rules = {},
  widthLabel = null,
  inline = false,
  disabled = false,
  isLockable = false,
  label = null,
  placeholder = '',
  defaultValue,
  maxlength = null,
  className,
  // eslint-disable-next-line no-unused-vars
  ...rest
}, ref) => {
  const [lock, setLock] = useState(isLockable);
  const [textareaValue, setTextareaValue] = useState('');
  const [style, setStyle] = useState({});
  const textareaRef = useRef();
  const textareaWatch = useWatch({
    control,
    name,
  });

  function autosize() {
    const elt = textareaRef.current.querySelector('textarea');
    if (!elt) return;
    elt.style.cssText = 'height:auto; padding:0';
    elt.style.cssText = `height:${elt.scrollHeight}px`;
    setStyle({
      padding: '10px',
      height: `${elt.scrollHeight}px`,
    });
  }

  function getClassName() {
    let classValue = styles['container-textarea'];
    if (className) {
      classValue += ` ${styles[className]}`;
    }
    if (inline) {
      classValue += ` ${styles.inline}`;
    }
    if (disabled) {
      classValue += ` ${styles.disabled}`;
    }
    return classValue;
  }

  useImperativeHandle(ref, () => ({
    getValue: () => textareaValue,
    getObject: () => ({ [name]: textareaValue }),
    getElement: () => ref.current,
  }));

  useEffect(() => {
    setTextareaValue(textareaWatch);
  }, [textareaWatch]);

  useEffect(() => {
    autosize();
  }, []);

  return (
    <div
      ref={textareaRef}
      className={getClassName()}
    >
      {label && <label style={widthLabel ? { minWidth: widthLabel } : {}}>{label}</label>}
      <Controller
        name={name}
        control={control}
        rules={rules}
        defaultValue={defaultValue}
        render={({
          field: {
            // name,
            value = '',
            // ref,
            onChange,
          },
          formState: { isValid },
        }) => {
          function handleChangeValue(val) {
            if (!isValid && val === '\n') {
              onChange('');
              return null;
            }
            onChange(val);
            autosize();
            return null;
          }

          return (
            <div className={styles.container}>
              <div className={
                isLockable ? `${styles.containerTextarea} ${styles.isLockable}` : styles.containerTextarea
              }>
                <textarea
                  // CONTROLLER -> FIELD PROPS
                  name={name}
                  ref={ref}
                  //
                  value={value}
                  className={disabled ? `${styles.input} ${styles.disabled}` : styles.input}
                  placeholder={placeholder}
                  maxLength={maxlength}
                  rows='8'
                  disabled={isLockable ? lock : disabled}
                  style={style}
                  onChange={(e) => {
                    handleChangeValue(e.target.value);
                  }}
                >
                </textarea>
                {isLockable && (
                  <span className={styles.locker}>
                    {!lock && <p onClick={() => onChange(defaultValue)}>Reset</p>}
                    <span onClick={() => setLock((state) => !state)}>
                      {lock ? <BiLock /> : <BiLockOpen />}
                    </span>
                  </span>
                )}
              </div>
              {(maxlength)
                && <p className={styles['count-characters']}>
                  {`${value ? value.length : 0} / ${maxlength}`}
                </p>
              }
            </div>
          );
        }

        }
      />
    </div>

  );
});

Textarea.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  rules: PropTypes.object,
  widthLabel: PropTypes.string,
  inline: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  maxLength: PropTypes.string,
};

export default Textarea;
